import type {
  IReservationAndInstantOfferStatusEvent,
  IReservationAndInstantOfferStatusInput,
} from '../types/clickEvents';

const reservationAndInstantOfferStatus = (
  input: IReservationAndInstantOfferStatusInput,
): Omit<IReservationAndInstantOfferStatusEvent, 'event'> => ({
  linkDetails: input.linkDetails,
  reservationStatus: input.reservationStatus,
});

export default reservationAndInstantOfferStatus;
